module.exports = __webpack_public_path__ + "img/light_ic_screen_landscape.efce6bdb.png";